var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ExpandableDetail"},[_c('details',{ref:"root",staticClass:"ExpandableDetail__Details"},[_c('summary',{ref:"summary",on:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}},[_vm._t("summary")],2),_c('div',{ref:"detail"},[_vm._t("detail")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }